import React from 'react';

interface PaginationProps {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
}

// Chỉ trình bày: dữ liệu và trang hiện tại do nơi gọi giữ
const Pagination: React.FC<PaginationProps> = ({ page, perPage, total, onPageChange }) => {
  if (perPage <= 0 || total <= perPage) return null;

  const last = Math.ceil(total / perPage);
  const btn =
    'px-3 py-1.5 text-sm font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <div className="flex items-center justify-between pt-4">
      <button type="button" className={btn} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        Trước
      </button>
      <span className="text-sm text-gray-600">{`Trang ${page}/${last}`}</span>
      <button type="button" className={btn} disabled={page >= last} onClick={() => onPageChange(page + 1)}>
        Sau
      </button>
    </div>
  );
};

export default Pagination;
